// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GenericLoader_wrapper__1RgMS","innerWrapper":"GenericLoader_innerWrapper__1YAyc","progress":"GenericLoader_progress__17yyj"};